import { Column } from "../../../../core/components/Column";
import { useParams } from "react-router-dom";
import { Button } from "../../../../core/components/Button";
import { Row } from "../../../../core/components/Row";
import { useEffect, useRef, useState } from "react";
import { urlBackend } from "../../../../core/constants/utils";
import { DateTime } from "luxon";
import { CheckIcon } from "../../../../core/icons/Check";
import { CopyIcon } from "../../../../core/icons/Copy";
import { RenderTable } from "../../../home/presentation/components/RenderTabe";
import { triggerConfetti } from "../../../../core/constants/function";
import { Countdown } from "../components/Countdown";
import { FinishTime } from "../components/LottieAnimtation";
import { TextComponent } from "../../../../core/components/TextComponent";
import { BGCircleLoading } from "../../../../core/components/BGCircleLoading";

interface Event {
	id: string;
	title: string;
	description: string;
	participants: string[];
	prizes: string[];
	date: string;
	hour: string;
	timezone: string;
	oneForOne: boolean;
	results: any;
	timeLottery: string;
	time: boolean;
}

export const Lottery: React.FC = () => {
	const { id } = useParams();
	const link = window.location.href;
	const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	const [isLinkCopied, setIsLinkCopied] = useState(false);
	const [data, setData] = useState<Event | null>(null);
	const [date, setDate] = useState("");
	const [hour, setHour] = useState("");
	const [finishTime, setFinishTime] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const resultRef = useRef<HTMLDivElement>(null);

	const handleResults = async () => {
		try {
			setIsLoading(true);
			const response = await fetch(`${urlBackend}event/${id}`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ timezone }),
			});
			if (!response.ok) {
				throw new Error("Evento no encontrado");
			}
			const data = await response.json();
			setData(data);
			if (data.time === false) {
				triggerConfetti(2);
				setIsLoading(false);
				return;
			}
			const eventDateTime = DateTime.fromISO(data.timeLottery);
			const formattedDate = eventDateTime.toLocaleString({
				weekday: "long",
				day: "numeric",
				month: "long",
				year: "numeric",
			});
			const formattedTime = eventDateTime.toFormat("HH:mm");
			setDate(formattedDate);
			setHour(formattedTime);
			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
			console.error("Error en la solicitud:", error);
		}
	};

	const handleCopyLink = () => {
		navigator.clipboard
			.writeText(link)
			.then(() => {
				setIsLinkCopied(true);
				setTimeout(() => {
					setIsLinkCopied(false);
				}, 3000);
			})
			.catch((error) => {
				console.error("Error al copiar el enlace: ", error);
			});
	};

	useEffect(() => {
		handleResults();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Column
			crossAxisAlignment="center"
			className="py-5 px-5 gap-3 md:gap-4"
		>
			{isLoading && (
				<Column
					className="h-[70svh]"
					crossAxisAlignment="center"
					mainAxisAlignment="center"
				>
					<BGCircleLoading className="w-20 aspect-square" />
				</Column>
			)}
			{!isLoading && data?.title && (
				<Column>
					<TextComponent
						variant="h1"
						className="tracking-wider text-orange-500 uppercase text-center font-lilita-one"
					>
						{data?.title}
					</TextComponent>
					{data?.description && (
						<TextComponent
							variant="h4"
							className="font-medium text-center text-gray-700"
						>
							{data?.description}
						</TextComponent>
					)}
				</Column>
			)}
			{!isLoading && data?.time && (
				<>
					{!finishTime ? (
						<Countdown
							data={data}
							date={date}
							hour={hour}
							setFinishTime={setFinishTime}
							eventDateTime={data.timeLottery}
						/>
					) : (
						<FinishTime handleResults={handleResults} />
					)}
				</>
			)}
			{data?.results && (
				<RenderTable
					result={data.results}
					ref={resultRef}
				/>
			)}
			{!isLoading && (
				<Button
					className="font-bold w-full"
					onClick={handleCopyLink}
					isDisabled={isLinkCopied}
					color="yellow"
				>
					<Row
						className="gap-1"
						crossAxisAlignment="center"
						mainAxisAlignment="center"
					>
						{isLinkCopied ? <CheckIcon className="w-5 h-5" /> : <CopyIcon className="w-5 h-5" />}
						<span>{isLinkCopied ? "¡El enlace ha sido copiado!" : "Copiar enlace de sorteo"}</span>
					</Row>
				</Button>
			)}
		</Column>
	);
};
